/* eslint-disable react/prop-types */
import React, { useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { Grid, Collapse, IconButton } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import { PHONE_BAR_BUTTON, PHONE_BAR_INSET } from './phoneTopBar';

const useStyles = makeStyles((theme) => ({
  infoContent: {
    display: 'flex',
    flexDirection: 'row',
    gap: '4px',
  },
  // The left end of the viewer's top bar on a phone-sized screen (see
  // phoneTopBar): the button sits on the line of the action buttons.
  infoOverlay: {
    position: 'absolute',
    top: PHONE_BAR_INSET,
    left: PHONE_BAR_INSET,
    zIndex: 22,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    maxWidth: '85%',
    pointerEvents: 'none',
  },
  infoIconButton: {
    color: '#ffffff',
    pointerEvents: 'auto',
    padding: (PHONE_BAR_BUTTON - 24) / 2,
  },
  infoPanel: {
    background: 'rgba(0,0,0,0.55)',
    borderRadius: 8,
    color: '#fff',
    margin: '0 4px',
    pointerEvents: 'auto',
  },
  infoTitle: {
    fontWeight: 'bold',
    fontSize: '0.87rem',
    textAlign: 'left',
    margin: '0px',
  },
  infoText: {
    fontSize: '0.87rem',
    textAlign: 'left',
    wordBreak: 'break-word',
    margin: '0px',
  },
  infoGridContainer: {
    padding: '8px',
  },
}));

// eslint-disable-next-line react/prop-types
export function InfoContent({ filePermission, project, dimensions, downSm }) {
  const classes = useStyles();

  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  const adderName =
    filePermission &&
      filePermission.user &&
      (filePermission.user.firstName || filePermission.user.lastName)
      ? `${filePermission.user.firstName} ${filePermission.user.lastName}`
      : '-';

  const [fileSize, setFileSize] = useState('');

  const infoGrid = (
    <Grid container spacing={2} className={classes.infoGridContainer}>
      <Grid item className={classes.infoContent}>
        <p className={classes.infoTitle}>{`${t('gallery.date_added')}:`}</p>
        <p className={classes.infoText}>{`${moment(
          filePermission.createdAt
        ).format('lll')}`}</p>
      </Grid>

      <Grid item className={classes.infoContent}>
        <p className={classes.infoTitle}>{`${t('gallery.added_by')}:`}</p>
        <p className={classes.infoText}>{adderName}</p>
      </Grid>

      <Grid item className={classes.infoContent}>
        <p className={classes.infoTitle}>{`${t('gallery.project')}:`}</p>
        <p className={classes.infoText}> {project.name}</p>
      </Grid>

      <Grid item className={classes.infoContent}>
        <p className={classes.infoTitle}>{`${t('gallery.image_size')}:`}</p>
        <p className={classes.infoText}>
          {Object.keys(dimensions).length > 0
            ? `${dimensions.width}x${dimensions.height}`
            : '-'}
        </p>
      </Grid>

      {/* {fileSize ? (
        <Grid item className={classes.infoContent}>
          <p className={classes.infoTitle}>{`${t('gallery.file_size')}:`}</p>
          <p className={classes.infoText}>
            {fileSize ? `${fileSize} ${t('file.kilobyte_short')}` : '-'}
          </p>
        </Grid>
      ) : null} */}

      {filePermission.description ? (
        <Grid item className={classes.infoContent}>
          <p className={classes.infoTitle}>{`${t('gallery.description')}:`}</p>
          <p className={classes.infoText}>
            {filePermission.description || '-'}
          </p>
        </Grid>
      ) : null}

      {filePermission.assignment ? (
        <Grid item className={classes.infoContent}>
          <p className={classes.infoTitle}>{`${t('expense.assignment')}:`}</p>
          <p className={classes.infoText}>{`${filePermission.assignment
            ? `${filePermission.assignment.number &&
            filePermission.assignment.number + '.'
            } ${filePermission.assignment.name}`
            : '-'
            }`}</p>
        </Grid>
      ) : null}

      {filePermission.assignment && filePermission.record ? (
        <Grid item className={classes.infoContent}>
          <p className={classes.infoTitle}>{`${t('common.work_amount')}:`}</p>
          <p className={classes.infoText}>{`${filePermission.assignment && filePermission.record
            ? `${filePermission.record.assignmentUnitAmount} ${filePermission.assignment.unit}`
            : '-'
            }`}</p>
        </Grid>
      ) : null}
    </Grid>
  );

  if (downSm) {
    return (
      <div
        className={classes.infoOverlay}
        onClick={(e) => e.stopPropagation()}
        onDoubleClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
        onMouseMove={(e) => e.stopPropagation()}
        onMouseUp={(e) => e.stopPropagation()}
        onWheel={(e) => e.stopPropagation()}
        onTouchStart={(e) => {
          if (e.touches.length < 2) e.stopPropagation();
        }}
        onTouchMove={(e) => {
          if (e.touches.length < 2) e.stopPropagation();
        }}
        onTouchEnd={(e) => {
          if (e.touches.length < 2) e.stopPropagation();
        }}
      >
        <IconButton
          className={classes.infoIconButton}
          onClick={() => setOpen((prev) => !prev)}
          size="medium"
          aria-label={t('gallery.show_info')}
        >
          <InfoIcon />
        </IconButton>
        <Collapse in={open}>
          <div className={classes.infoPanel}>{infoGrid}</div>
        </Collapse>
      </div>
    );
  }

  return infoGrid;
}
